import { tv, VariantProps } from "@/utils";

export const video = tv({
  slots: {
    base: ["group/item", "relative", "overflow-hidden", "bg-primary-900"],
    figure: [
      "absolute z-20",
      "w-full h-full",
      "cursor-pointer",
      "transition-opacity duration-300",
      "after:w-full after:h-full",
      "after:absolute after:inset-0",
      "after:bg-black/75",
      "after:transition-opacity duration-300",
    ],
    background: [
      "object-cover object-center",
      "select-none",
      "pointer-events-none",
    ],
    caption: [
      "flex flex-col gap-10 justify-center items-center",
      "text-center",
      "w-full h-full",
      "absolute inset-0 z-20",
      "m-auto",
    ],
    title: ["text-white", "max-w-md"],
    label: ["text-white"],
    button: [
      "group-hover/item:scale-110",
      "bg-primary-500 ring-8 ring-primary-500/50",
      "flex items-center justify-center",
      "rounded-full",
      "w-16 h-16",
      "transition-transform duration-300",
      "pointer-events-none select-none",
    ],
    icon: ["w-5 h-5", "translate-x-0.5", "text-white"],
    player: ["aspect-square sm:aspect-video"],
    iframe: ["w-full h-full"],
  },
  variants: {
    playing: {
      true: {
        figure: ["opacity-0"],
      },
    },
  },
  defaultVariants: {
    playing: false,
  },
});

export type VideoVariantProps = VariantProps<typeof video>;

export type VideoReturnVariantProps = ReturnType<typeof video>;
